module.exports = __webpack_public_path__ + "static/img/tu12.aedc840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tu12.png
// module id = NqzY
// module chunks = 10